import { formatVND } from "../../utils/formatVND";
import { Box } from "@primer/react";
import { useContext } from "react";
import { IDataGridColumn, ISummaryItem } from "./type/IDataGridProps";
import styles from "./DataGrid.module.css";

import {
  DataGridContainerContext,
  IDataGridContainerContext,
} from "./DataGrid";
import clsx from "clsx";
import { backgroundClip } from "html2canvas/dist/types/css/property-descriptors/background-clip";
interface ITotalSummaryProps {
  dataColumns: IDataGridColumn[];
  totalSummary: ISummaryItem[];
  stickyOffsets: any;
  filterdData: any[];
}
const SumIcon = () => {
  return (
    <img
      src="../../images/sum.svg"
      style={{
        width: "1rem",
      }}
    />
  );
};
const calculateSummaryItem = (sumItem: ISummaryItem, data: any[]): any => {
  const { dataField, summaryType } = sumItem;
  const values = data
    .map((item) => item?.[dataField])
    .filter((v) => v !== undefined && v !== null);
  switch (summaryType) {
    case "sum":
      return values.reduce((total, v) => total + Number(v), 0);

    case "count":
      return values.length;

    case "min":
      if (values.length === 0) return null;
      return Math.min(...values.map((v) => Number(v)));

    case "max":
      if (values.length === 0) return null;
      return Math.max(...values.map((v) => Number(v)));

    default:
      return null;
  }
};
const defaultRender = (sumItem: ISummaryItem, sumValue: any) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {sumItem.summaryType === "sum" && <SumIcon />}
      <Box sx={{ flex: 1 }}>
        {sumValue && sumValue > 0 ? <>{formatVND(sumValue)}</> : "-"}
      </Box>
    </Box>
  );
};

const TotalSummary = (props: ITotalSummaryProps) => {
  const { totalSummary, dataColumns, stickyOffsets,filterdData } = props;

  return (
    <tfoot
      style={{
        position: "sticky",
        bottom: 0,
        zIndex: 20,
        background: "#f7f8fa",
      }}
    >
      <tr>
        {dataColumns.filter(x=>x.isVisible===true).map((column: any, idx: number) => {
          const sumItem = totalSummary?.find(
            (x) => x.dataField === column.dataField,
          );
          const sumValue = sumItem
            ? calculateSummaryItem(sumItem, filterdData)
            : undefined;
          const cellStyle = {
            width: column.width,
            minWidth: column.minWidth,
            fontWeight: column.isMainColumn ? "600" : 400,
            whiteSpace: "break-spaces" as const,
            textAlign: column.align ?? "right",
            position: column.fixed ? "sticky" : "relative",
            left:
              column.fixed === "left"
                ? stickyOffsets.leftOffsets[column.uuid ?? ""]
                : undefined,
            right:
              column.fixed === "right"
                ? stickyOffsets.rightOffsets[column.uuid ?? ""]
                : undefined,

            zIndex: column.fixed ? 15 : 1,
            backgroundColor :"#f7f8fa"

          } as any;
          return (
            <td style={cellStyle}
              className={clsx(
                column.fixed ? styles.fixed : "",
                column.fixed === "left" ? styles.left : "",
                column.fixed === "right" ? styles.right : "",
                column.isLastColFixed ? styles.lastFixed : "",
              )}
              key={idx}
            >
              {sumItem && (
                <Box>
                  {sumItem.customizeRender
                    ? sumItem.customizeRender(filterdData, sumValue)
                    : defaultRender(sumItem, sumValue)}
                </Box>
              )}
            </td>
          );
        })}
      </tr>

    </tfoot>
  );
};

export default TotalSummary;
